import { FaEraser, FaPlus, FaSearch } from "react-icons/fa";
import Button from "../../../../components/button/button";
import { Template } from "../../../../components/template/template";
import { Card } from "../../../../components/card/card";
import InputForm from "../../../../components/input/input-form";
import { AgGridReact } from "ag-grid-react";
import AgGridUtils from "../../../../utils/aggrid-utils";
import { navigateHook } from "../../../../hooks/use-navigate";
import { useMemo, useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import EquipmentsService from "../../../../services/web/equipments-service";
import aggridUtils from "../../../../utils/aggrid-utils";

const initialFilter = {
    filter: [],
    page: 1,
    size: 500,
    sort: [{ field: "description", dir: "asc" }],
};

export default function EquipmentsList() {
    const navigate = navigateHook();
    const [description, setDescription] = useState("");
    const [filter, setFilter] = useState(initialFilter);

    const { data: equipments = [], isLoading } = useQuery({
        queryKey: ['equipments', filter],
        queryFn: () => EquipmentsService.list(filter).then(({ data }) => data.data ?? []),
    });

    const columnDefs = useMemo(() => ([
        { headerName: "Nome", field: "description", flex: 1, sortable: true, comparator: aggridUtils.lowerUpCaseComparator},
    ]), []);

    const gridRef = useRef(null);
    const goFirstPage = () => gridRef.current?.api?.paginationGoToFirstPage();

    const handleSearch = () => {
        setFilter({
            ...filter,
            page: 1,
            filter: description
                ? [{ field: "description", op: "like", value: description }]
                : [],
        });
        goFirstPage();
    };

    const handleClear = () => {
        setDescription("");
        setFilter(initialFilter);
        goFirstPage();  
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSearch();
        if (e.key === "Escape") handleClear();
    };

    const onCellClicked = ({ data, event }) => {
        if (!data?.id) return;
        
        const urlDev = `/equipments/form/${data.id}`;
        let isBlank = !!event.ctrlKey;
        navigate(urlDev, isBlank);
    };

    const newEquipment = () => {
        const urlDev = "/equipments/form";
        navigate(urlDev);
    };

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Equipamentos de zeladoria</Template.Title>
                <Button onClick={newEquipment}><FaPlus />Adicionar equipamento</Button>
            </Template.Header>
            <Template.Body className="flex flex-col gap-2">
                <Card>
                    <Card.Body>
                        <div className="flex gap-4 items-end aggrid-row-pointer">
                            <InputForm 
                                id="description"
                                label="Nome"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                onKeyDown={handleKeyDown}
                                classNameWrapper="flex-1"
                            />
                            <div className="flex gap-2">
                                <Button
                                    target="primary-outline"
                                    title="Limpar"
                                    onClick={handleClear}
                                >
                                    <FaEraser />
                                </Button>
                                <Button
                                    title="Buscar"
                                    onClick={handleSearch}
                                >
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact 
                                ref={gridRef}
                                rowData={equipments}
                                columnDefs={columnDefs}
                                defaultColDef={{ resizable: false }}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus
                                onCellClicked={onCellClicked}
                                gridOptions={{ localeText: AgGridUtils.localization() }}
                                theme={AgGridUtils.generalTheme()}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>    
    )
}